import { taskDeconstructHull } from '../behavior/taskDeconstructHull-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'

export function run(t: ITileShip, isLeft: boolean, isGodMode: boolean) {
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()

  let currentBlueprint = blueprints.findAtSpot(
    t.i,
    t.j,
    (c) => c.data.type === 'deconstruct-hull' || c.data.type === 'debuild',
  )
  if (isLeft) {
    if (!currentBlueprint) {
      if (
        machines.findAtSpot(t.i, t.j, (c) => true) ||
        stacks.findAtSpot(t.i, t.j, (c) => true)
      ) {
        let bp = blueprints.create('debuild')
        blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
      } else if (t.dataFloor) {
        if (isGodMode) {
          taskDeconstructHull.forceDeconstructHull(t.i, t.j)
        } else {
          let bp = blueprints.create('deconstruct-hull')
          blueprints.moveToTile(bp, ctx.mapShip, t.i, t.j)
        }
      }
    }
  } else {
    if (currentBlueprint) {
      blueprints.kill(currentBlueprint)
    }
  }
}
